import React, { useMemo, useState } from 'react';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';

export function useSort(initialKey = null, initialDir = 'asc') {
  const [sort, setSort] = useState({ key: initialKey, dir: initialDir });
  const toggle = (key) => setSort(s => ({
    key,
    dir: s.key === key ? (s.dir === 'asc' ? 'desc' : 'asc') : 'asc',
  }));
  return [sort, toggle];
}

export function sortArr(arr, sort, get) {
  if (!sort.key) return arr;
  const copy = [...arr];
  copy.sort((a, b) => {
    const va = get(a, sort.key);
    const vb = get(b, sort.key);
    if (va == null && vb == null) return 0;
    if (va == null) return 1;
    if (vb == null) return -1;
    if (typeof va === 'number' && typeof vb === 'number') return sort.dir === 'asc' ? va - vb : vb - va;
    return sort.dir === 'asc' ? String(va).localeCompare(String(vb)) : String(vb).localeCompare(String(va));
  });
  return copy;
}

export default function SortHeader({ sort, onToggle, k, label, align = 'left', className = '' }) {
  const active = sort.key === k;
  const Icon = !active ? ArrowUpDown : sort.dir === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th
      onClick={() => onToggle(k)}
      className={`px-3 py-2 text-[10px] uppercase tracking-[0.15em] font-medium cursor-pointer select-none hover:text-zinc-900 ${active ? 'text-zinc-900' : 'text-zinc-600'} text-${align} ${className}`}
      data-testid={`sort-${k}`}
    >
      <span className={`inline-flex items-center gap-1 ${align === 'right' ? 'flex-row-reverse' : ''}`}>
        {label}<Icon size={10} className={active ? 'opacity-100' : 'opacity-40'} />
      </span>
    </th>
  );
}
